module.exports = __webpack_public_path__ + "static/img/justyn-warner-529957-unsplash.445df84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/justyn-warner-529957-unsplash.png
// module id = bhsI
// module chunks = 37